import React from "react";
import { Link } from "react-router-dom";

const Project = ({ project }) => {
  return (
    <Link
      to={`/project/${project.id}`}
      key={project.id}
      // className="flex pb-4 flex-col hover:bg-secondary hover:cursor-pointer hover:shadow-none items-center text-center  border-2 border-secondary rounded-2xl shadow-xl shadow-secondary"
      className="bg-secondary flex pb-4 flex-col items-center text-center border-2 border-tertiary rounded-2xl shadow- shadow-tertiary 
       hover:cursor-pointer 
      transition-transform duration-300 ease-in-out hover:scale-105"
    >
      <div className="mb-8">
        <img
          className="rounded-t-2xl w-full h-auto"
          src={project.image}
          alt=""
        />
      </div>
      <p className="capitalize text-accent text-sm mb-3">{project.category}</p>
      <h3 className="text-2xl font-semibold capitalize mb-3">{project.name}</h3>
      <p className="text-base max-w-md text-st">{project.description}</p>
    </Link>
  );
};

export default Project;
